module.exports = {
      id: "textsms-usage",
      viewBox: "0 0 28.57 28.57",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#textsms",
      toString: function () {
        return this.url;
      }
    }